import sepLogo from '../assets/images/gateways/sep.png';
import zarinpalLogo from '../assets/images/gateways/zarinpal.png';
import pecLogo from '../assets/images/gateways/pec.png';
import pnaLogo from '../assets/images/gateways/pna.png';
import digipayLogo from '../assets/images/gateways/digipay.png';

export const GATEWAY_LOGOS = {
  sep: sepLogo,
  saman: sepLogo,
  zarinpal: zarinpalLogo,
  zarin: zarinpalLogo,
  pec: pecLogo,
  parsian: pecLogo,
  newpg: pecLogo,
  iec: pecLogo,
  pna: pnaLogo,
  digipay: digipayLogo,
};

export function getGatewayLogo(key) {
  if (!key) return null;
  return GATEWAY_LOGOS[String(key).toLowerCase()] || null;
}
